import React from 'react';
import PersonaIdea from './PersonaIdea';
import PotentialIdeas from './PotentialIdeas';
import { Button } from '@salesforce/design-system-react';

const PersonaMethod = (props) => {
  return (
    <React.Fragment>
      <div key="milestone-idea-button">
        <p className="grey-font slds-text-heading_medium slds-align_absolute-center">Add {props.methodName == "Responsibility" ? "Relevant Info" : ("Persona " + props.methodName)}</p>
        <Button
          variant="brand"
          onClick={props.onButtonClick}
          className="slds-m-top_small slds-align_absolute-center add-idea-button"
        />
        </div>
        <PotentialIdeas
          personaId={props.personaId}
          methodName={props.methodName}
          ideas={props.ideas}
          title={props.title}
          onDropdownSelected={props.onDropdownSelected}
          openEditIdea={props.openEditIdea}
        />
    </React.Fragment>
  );
};

export default PersonaMethod;
